import React from "react";
import "../../styles/base.css";
import "../../styles/board.css";
import "../../styles/common.css?ver=1";
import "../../styles/is.css?ver=2";
import Neat_home from "../../assets/neat_home.jpg";
import Pf_02 from "../../assets/pf_02.jpg";
import Pf_03 from "../../assets/pf_03.jpg";
import Pf_05 from "../../assets/pf_05.jpg";
import Pf_09 from "../../assets/pf_09.jpg";
import Pf_10 from "../../assets/cj_image.png";
import Pf_11 from "../../assets/amis_home.jpg";
import Pf_12 from "../../assets/aom_home.png";

function Rslt_portfolio() {
  return (
    <>
      <div className="boardListArea">
        <div className="srboardList">
          <div className="listGallery">
            <div className="gallListArea">
              <div className="colUll">
                <ul>
                  <li>
                    <dl>
                      <dt>
                        <a
                          className="bbs-img"
                          style={{ backgroundImage: `url(${Pf_12})` }}
                        ></a>
                      </dt>
                      <dd className="title">
                        <p
                          style={{
                            color: "#333333",
                            fontSize: "22px",
                            fontFamily: "Noto Sans Korean, sans-serif",
                          }}
                        >
                          농수산물 온라인도매시장
                        </p>
                        <a
                          className="tit-content"
                          href="https://kafb2b.or.kr/client/mn/main/main.do"
                          target="_blank"
                        ></a>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        <a
                          className="bbs-img"
                          style={{ backgroundImage: `url(${Pf_11})` }}
                        ></a>
                      </dt>
                      <dd className="title">
                        <p
                          style={{
                            color: "#333333",
                            fontSize: "22px",
                            fontFamily: "Noto Sans Korean, sans-serif",
                          }}
                        >
                          농촌진흥청 농업경영종합정보시스템
                        </p>
                        <a
                          className="tit-content"
                          href="https://amis.rda.go.kr/portal/portalMain/main"
                          target="_blank"
                        ></a>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        <a
                          className="bbs-img"
                          style={{ backgroundImage: `url(${Pf_10})` }}
                        ></a>
                      </dt>
                      <dd className="title">
                        <p
                          style={{
                            color: "#333333",
                            fontSize: "22px",
                            fontFamily: "Noto Sans Korean, sans-serif",
                          }}
                        >
                          CJ프레시웨이 FS 메뉴관리 시스템
                        </p>
                        <a
                          className="tit-content"
                          href="https://ns.eat.co.kr/NeaT/eats/index.html"
                          target="_blank"
                        ></a>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        <a
                          className="bbs-img"
                          style={{ backgroundImage: `url(${Pf_05})` }}
                        ></a>
                      </dt>
                      <dd className="title">
                        <p
                          style={{
                            color: "#333333",
                            fontSize: "22px",
                            fontFamily: "Noto Sans Korean, sans-serif",
                          }}
                        >
                          B2B 기업간 전자상거래
                        </p>
                        <a
                          className="tit-content"
                          href="https://www.eat.co.kr:444/index.jsp"
                          target="_blank"
                        ></a>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        <a
                          className="bbs-img"
                          style={{ backgroundImage: `url(${Neat_home})` }}
                        ></a>
                      </dt>
                      <dd className="title">
                        <p
                          style={{
                            color: "#333333",
                            fontSize: "22px",
                            fontFamily: "Noto Sans Korean, sans-serif",
                          }}
                        >
                          공공급식 통합 플랫폼
                        </p>
                        <a className="tit-content" target="_blank"></a>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        <a
                          className="bbs-img"
                          style={{ backgroundImage: `url(${Pf_02})` }}
                        ></a>
                      </dt>
                      <dd className="title">
                        <p
                          style={{
                            color: "#333333",
                            fontSize: "22px",
                            fontFamily: "Noto Sans Korean, sans-serif",
                          }}
                        >
                          축산물 이력제
                        </p>
                        <a
                          className="tit-content"
                          href="http://aunit.mtrace.go.kr/"
                          target="_blank"
                        ></a>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        <a
                          className="bbs-img"
                          style={{ backgroundImage: `url(${Pf_09})` }}
                        ></a>
                      </dt>
                      <dd className="title">
                        <p
                          style={{
                            color: "#333333",
                            fontSize: "22px",
                            fontFamily: "Noto Sans Korean, sans-serif",
                          }}
                        >
                          친환경 인증관리 정보시스템
                        </p>
                      </dd>
                    </dl>
                  </li>

                  <li>
                    <dl>
                      <dt>
                        <a
                          className="bbs-img"
                          style={{ backgroundImage: `url(${Pf_03})` }}
                        ></a>
                      </dt>
                      <dd className="title">
                        <p
                          style={{
                            color: "#333333",
                            fontSize: "22px",
                            fontFamily: "Noto Sans Korean, sans-serif",
                          }}
                        >
                          학교급식 전자조달 시스템
                        </p>
                        <a
                          className="tit-content"
                          href="https://ns.eat.co.kr/NeaT/eats/index.html"
                          target="_blank"
                        ></a>
                      </dd>
                    </dl>

                  </li>                    

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Rslt_portfolio;
